import React, { useEffect, useState } from "react";
import { ComboBox, IComboBoxOption } from "@fluentui/react";
import { getCustomers, Customer } from "@/api/customers";

interface CustomerComboBoxProps {
  label?: string;
  selectedCustomerId?: number;
  onChange: (customerId: number | undefined) => void;
  disabled?: boolean;
  placeholder?: string;
  errorMessage?: string;
}

let cachedCustomers: Customer[] | null = null;
let cachePromise: Promise<Customer[]> | null = null;

const loadCustomers = (): Promise<Customer[]> => {
  if (cachedCustomers) {
    return Promise.resolve(cachedCustomers);
  }
  if (!cachePromise) {
    cachePromise = getCustomers().then((data) => {
      cachedCustomers = data || [];
      return cachedCustomers;
    });
  }
  return cachePromise;
};

const CustomerComboBox = (props: CustomerComboBoxProps) => {
  const [options, setOptions] = useState<IComboBoxOption[]>([]);

  useEffect(() => {
    loadCustomers().then((customers) => {
      setOptions(
        customers.map((c) => ({
          key: c.Id,
          text: `${c.Name} (${c.Id})`,
        }))
      );
    });
  }, []);

  return (
    <ComboBox
      label={props.label ?? "Customer"}
      options={options}
      selectedKey={props.selectedCustomerId ?? null}
      onChange={(_, option) =>
        props.onChange(option ? (option.key as number) : undefined)
      }
      allowFreeform
      autoComplete="on"
      disabled={props.disabled}
      placeholder={props.placeholder ?? "Search customer..."}
      errorMessage={props.errorMessage}
    />
  );
};

export default CustomerComboBox;

export const findCustomerName = (customerId: number): string | undefined =>
  cachedCustomers?.find((c) => c.Id === customerId)?.Name;
